import React from "react";
import { Link } from "react-router-dom";

import veggieGyozaMenu from "../../assets/images/resource/menu/vegetable/veggie-gyoza.webp";
import jungleSaladMenu from "../../assets/images/resource/menu/vegetable/jungle-salad.webp";
import ubeTempuraMenu from "../../assets/images/resource/menu/vegetable/ube-tempura.webp";
import sweetCornMenu from "../../assets/images/resource/menu/vegetable/sweet-corn.webp";

import agedashiTofuMenu from "../../assets/images/resource/menu/vegetable/agedashi-tofu.webp";
import shishitoPepperMenu from "../../assets/images/resource/menu/vegetable/shishito-pepper.webp";
import cornRibsMenu from "../../assets/images/resource/menu/vegetable/corn-ribs.webp";
import brusselSproutsMenu from "../../assets/images/resource/menu/vegetable/brussel-sprouts.webp";

import cucumberSaladMenu from "../../assets/images/resource/menu/vegetable/cucumber-salad.webp";
import spicyMenmaMenu from "../../assets/images/resource/menu/vegetable/spicy-menma.webp";

import yamazakiCabbageMenu from "../../assets/images/resource/menu/vegetable/yamasaki-cabbage.webp";
import edamameMenu from "../../assets/images/resource/menu/vegetable/edamame.webp";
import vegetableImage from "../../assets/images/resource/vegetable.png";
function Vegetable() {
  return (
    <>
      <section className="menu-two">
        <div className="auto-container">
          <div className="title-box centered">
            <h2>Vegetable</h2>
          </div>
          <div className="row clearfix">
            <div className="menu-col col-lg-6 col-md-12 col-sm-12">
              <div className="inner">
                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={veggieGyozaMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">
                            Veggie Gyoza <span className="s-info">5 PCS.</span>
                          </Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$14.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">Homemade pan-fried veggie dumplings</Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={jungleSaladMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">
                            Jungle Salad
                            <span className="s-info">CONTAIN PISTACHIO</span>
                          </Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$16.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Assorted vegetables & seared tofu, tempura flake mixed
                        with homemade creamy sesame dressing
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={ubeTempuraMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Ube tempura</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$14.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Crispy purple yam served with 3 dipping dressing (Spicy
                        mayo/ wasabi mayo/ ponzu)
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={sweetCornMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Sweet corn cheese</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$12.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Grilled sweet corn with mozzarella cheese served in a
                        hot plate
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={agedashiTofuMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Agedashi Tofu</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$14.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Deep-fried organic tofu in tsuyu sauce topped with
                        radish, bonito flake, scallion & nori
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={shishitoPepperMenu} alt="" />
                      </Link>
                      &nbsp;
                      <img
                        src={vegetableImage}
                        alt="Icon"
                        width={30}
                        height={30}
                      ></img>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Shishito peppers</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$13.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Roasted peppers with homemade seasoning
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="menu-col col-lg-6 col-md-12 col-sm-12">
              <div className="inner">
                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={cornRibsMenu} alt="" />
                      </Link>
                      &nbsp;
                      <img
                        src={vegetableImage}
                        alt="Icon"
                        width={30}
                        height={30}
                      ></img>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Corn ribs</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$13.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Fresh deep-fried corn mixed with cheese powder
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={brusselSproutsMenu} alt="" />
                      </Link>
                      &nbsp;
                      <img
                        src={vegetableImage}
                        alt="Icon"
                        width={30}
                        height={30}
                      ></img>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Brussel sprouts</Link>
                          &nbsp;
                          <img
                            src={vegetableImage}
                            alt="Icon"
                            width={30}
                            height={30}
                          ></img>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$13.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Fresh deep-fried brussel sprout with blood orange mixed
                        with homemade dressing.
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={cucumberSaladMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Cucumber Salad</Link>
                          &nbsp;
                          <img
                            src={vegetableImage}
                            alt="Icon"
                            width={30}
                            height={30}
                          ></img>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$9.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Japanese style spicy marinated cucumber
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={spicyMenmaMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Spicy Menma</Link>
                          &nbsp;
                          <img
                            src={vegetableImage}
                            alt="Icon"
                            width={30}
                            height={30}
                          ></img>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$9.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Seasoning bamboo shoots with homemade 5 spicy peppers
                        oil
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={yamazakiCabbageMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Yamitsuki Cabbage</Link>
                          &nbsp;
                          <img
                            src={vegetableImage}
                            alt="Icon"
                            width={30}
                            height={30}
                          ></img>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$9.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Crunchy cabbage tossed in sesame oil and homemade
                        seasonings
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={edamameMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Edamame</Link>
                          &nbsp;
                          <img
                            src={vegetableImage}
                            alt="Icon"
                            width={30}
                            height={30}
                          ></img>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$10.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#"></Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Vegetable;
